import { useState } from "react";
import { useDisclosure, useToast } from "@chakra-ui/react";
import apiClient from "../../../Configuration/apiClient";
import API_CONFIG from "../../../Configuration/apiConfig";

export function useAdjustedQty({ getStoreId, getAuditedDate }) {
  const [adjustedQtyData, setAdjustedQtyData] = useState([]);
  const [isLoadingAdjustedQty, setIsLoadingAdjustedQty] = useState(false);
  const [adjustedQtyError, setAdjustedQtyError] = useState(null);

  const { isOpen: isAdjustedQtyOpen, onOpen: onAdjustedQtyOpen, onClose: onAdjustedQtyClose } = useDisclosure();
  const toast = useToast({ position: "top" });

  const handleAdjustedQty = async () => {
    const storeId = getStoreId();
    const auditedDateRaw = getAuditedDate();

    if (!storeId || !auditedDateRaw) {
      toast({
        title: "Missing Data",
        description: "Store or audit date information is missing.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const auditedDate = new Date(auditedDateRaw);
    const date  = auditedDate.getDate();
    const month = auditedDate.getMonth() + 1;
    const year  = auditedDate.getFullYear();

    setAdjustedQtyError(null);
    setIsLoadingAdjustedQty(true);
    onAdjustedQtyOpen();

    try {
      const res = await apiClient.get(
        `${API_CONFIG.RECALCULATION_BASE_URL}${API_CONFIG.ENDPOINTS.STORE_REPORT.RECALCULATION}/adjusted-stock?storeId=${storeId}&date=${date}&month=${month}&year=${year}`
      );
      setAdjustedQtyData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setAdjustedQtyError(err.response?.data?.message || "Failed to load adjusted quantity data.");
      setAdjustedQtyData([]);
    } finally {
      setIsLoadingAdjustedQty(false);
    }
  };

  return {
    handleAdjustedQty,
    adjustedQtyData,
    isLoadingAdjustedQty,
    adjustedQtyError,
    isAdjustedQtyOpen,
    onAdjustedQtyClose,
  };
}